export const correlativoModel = {
  td: null,
  se: null,
  nc: null,
  sn: null,
  cu: null,
};
